// External libraries
import React from 'react';
import styled from 'styled-components';

// Icon code
import { Icon } from './_base';

const LinkedInInvertedSVG = styled(Icon).attrs({ viewBox: '0 0 20 20' })`
    width: 1em;
`;

function LinkedInInvertedIcon({ color = 'currentColor', ...props }) {
    return (
        <LinkedInInvertedSVG data-test="icon-linkedin" {...props}>
            <path
                d="M15.833 0H4.167A4.167 4.167 0 000 4.167v11.666C0 18.134 1.866 20 4.167 20h11.666A4.167 4.167 0 0020 15.833V4.167C20 1.866 18.135 0 15.833 0zM6.667 15.833h-2.5V6.667h2.5v9.166zM5.417 5.61a1.465 1.465 0 01-1.459-1.47c0-.812.654-1.47 1.459-1.47s1.458.658 1.458 1.47c0 .812-.652 1.47-1.458 1.47zm11.25 10.223h-2.5v-4.67c0-2.806-3.334-2.594-3.334 0v4.67h-2.5V6.667h2.5v1.47c1.164-2.155 5.834-2.314 5.834 2.064v5.632z"
                fill={color}
            />
        </LinkedInInvertedSVG>
    );
}

export { LinkedInInvertedIcon as default, LinkedInInvertedIcon };
